import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { notificationKeys } from "@/lib/query-keys";
import type { AppNotification } from "@/types/domain";

type NotificationPage = {
  items: AppNotification[];
  nextCursor: number | null;
};

/** Lista paginada de notificaciones del usuario (infinite scroll por cursor). */
export function useNotifications(enabled = true) {
  return useInfiniteQuery({
    queryKey: notificationKeys.list,
    enabled,
    initialPageParam: undefined as number | undefined,
    queryFn: async ({ pageParam }) => {
      const res = await fetchToBackend<NotificationPage>(
        `/notifications${buildQuery({ cursor: pageParam })}`,
      );
      return {
        items: res?.items ?? [],
        nextCursor: res?.nextCursor ?? null,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });
}

/** Conteo de notificaciones sin leer; se refresca en segundo plano. */
export function useUnreadCount(enabled = true) {
  return useQuery({
    queryKey: notificationKeys.unreadCount,
    enabled,
    refetchInterval: 60_000,
    queryFn: async () => {
      const res = await fetchToBackend<{ count: number }>(
        "/notifications/unread-count",
      );
      return res.count ?? 0;
    },
  });
}
